import "./radio-button.css";
const RadioButton = ({ name, value, isSelected, isDisabled }) => {
  return (
    <div className="radio__button">
      <label htmlFor={`radio-${value}`}>
        <input
          id={`radio-${value}`}
          type="radio"
          name={name}
          value={value}
          disabled={isDisabled}
          checked={isSelected}
        />
        <span>{value}</span>
      </label>
    </div>
  );
};
export default RadioButton;
